// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'



/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?3af1ab9f99724e1a5288f35581be0a26";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    if (window._hmt) {
      if (to.path) {
        window._hmt.push(['_trackPageview', '/#' + to.fullPath])
      }
    }
    next();
});

import VueI18n from 'vue-i18n';
Vue.use(VueI18n)
//语言默认中文
var lang = localStorage.getItem("lang") || "zh"; //切换“zh”/“en”，可以切换中英文显示
Vue.config.lang = lang;
// Vue.config.productionTip = false; //阻止启动生产消息；
// //引入需要使用的语言文件
import zh from '@/lang/zh.js' // 中文语言包地址，例如：@/util/lang/zh.js
import en from '@/lang/en.js' //英文语言包
const messages = {
    zh,
    en,
}
Vue.prototype.$zh = zh
Vue.prototype.$en = en
// 遍历语言文件并且挂载到vue中this上
Object.keys(messages).forEach(function (lang) {
  console.log(lang)
  Vue.locale(lang, messages[lang]);
});
// const i18n = new VueI18n({
//   // locale:zh,
//   // messages:{
//   //   'zh':zh, //中文繁体包
//   //   'en':en, //英文语言包    
//   // }
// })
new Vue({
  el: '#app',
  router,
  // i18n,
  template: '<App/>',
  components: { App }
})　　　



// WEBPACK FOOTER //
// ./src/main.js